module.exports = __webpack_public_path__ + "img/not-found-page.b47ba556.png";